import { useEffect, useState } from 'react'
import './index.css'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
const History = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  // const roomId = localStorage.getItem('roomId')
  useEffect(() => {
    getAllLogs()
  }, [])
  const getAllLogs = () => {
    const config = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    }
    fetch(`${process.env.REACT_APP_SERVER_SOCKET}/api/room/history`, config)
      .then((response) => response.json())
      .then((result) => {
        setData(result?.data || [])
        setLoading(false)
      })
      .catch((error) => console.error(error?.message))
  }

  return loading ? (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <div style={{ margin: 'auto', padding: '2rem' }}>
        <h1 style={{ display: 'flex' }}>
          {' '}
          <div
            style={{ marginTop: '-5px', cursor: 'pointer', height: '10px' }}
            onClick={() => navigate('/')}
          >
            &larr;
          </div>
          Activity Log
        </h1>
        {data?.length ? (
          <table>
            <thead>
              <tr>
                {/* <th>Id</th> */}
                <th>User</th>
                <th>Action</th>
                <th>Details</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={index}>
                    {/* <td>{item?.id}</td> */}
                    <td>{item?.user_email}</td>
                    <td>{item?.action}</td>
                    <td>{item?.details?.text}</td>
                    <td>{moment(item?.created_at).format('LLL')}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <h2>No Activity Log found</h2>
        )}
      </div>
    </>
  )
}
export default History
